import is from '@sindresorhus/is';

import type { SkillShort } from '~/shared/data-contract/skill';
import type { TranslationKey } from '~/shared/internationalization/translation';

import { languagesMap } from '../app/common/enums-translation-mappers';
import type { LearningOpportunity, LearningOpportunityCreate, LearningOpportunityState } from './data-contract';

export const editableLearningOpportunityStates = ['draft', 'published', 'archived'] as const;
export type EditableLearningOpportunityState = (typeof editableLearningOpportunityStates)[number];
export const learningLanguageCodes = Object.keys(languagesMap);

export type LearningOpportunitySkillMutation = NonNullable<LearningOpportunityCreate['skills']>[number];

export const stateTranslationKey = (state: LearningOpportunityState): TranslationKey =>
    `pages.learning-opportunities.states.${state}` as TranslationKey;

export const getLearningLanguageLabel = (
    languageValue: string | undefined,
    translate: (key: TranslationKey) => string,
): string | undefined => {
    if (is.undefined(languageValue) || is.emptyString(languageValue)) return undefined;

    if (Object.hasOwn(languagesMap, languageValue)) {
        return translate(languagesMap[languageValue as keyof typeof languagesMap]);
    }

    return languageValue;
};

export const mapSkillToLearningOpportunityPayload = (skill: SkillShort): LearningOpportunitySkillMutation =>
    typeof skill.level === 'number' ? { id: skill.id, level: skill.level } : { id: skill.id };

export const buildLearningOpportunityUpdatePayload = (
    opportunity: LearningOpportunity,
    state: EditableLearningOpportunityState,
): LearningOpportunityCreate => ({
    custom: opportunity.custom,
    learningLanguage: opportunity.learningLanguage,
    provider: opportunity.provider,
    skills: opportunity.skills?.map(mapSkillToLearningOpportunityPayload),
    state,
    translations: opportunity.translations,
    type: opportunity.type,
    url: opportunity.url,
});
